import {DateRange} from 'react-date-range';
import {InputAdornment, Popover, TextField} from '@mui/material';
import {useState} from 'react';
import IconButton from '@mui/material/IconButton';
import ClearIcon from '@mui/icons-material/Clear';
import moment from 'moment';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
/* eslint-disable react/prop-types */

const formatFilterLabelDate = (date) => moment(date).local().format('MMM D, YYYY');

const DateRangePicker = ({column, header}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [awaitingEndDate, setAwaitingEndDate] = useState(false);
    const [selectedDateRange, setSelectedDateRange] = useState([
        {
            startDate: undefined,
            endDate: undefined,
            key: 'selection',
        },
    ]);

    const handleClick = (event) => {
        setAwaitingEndDate(false);
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAwaitingEndDate(false);
        setAnchorEl(null);
    };

    const applyRange = (startDate, endDate) => {
        column.setFilterValue([
            moment(startDate).startOf('day').toISOString(),
            moment(endDate).endOf('day').toISOString(),
        ]);
        setAwaitingEndDate(false);
        handleClose();
    };

    const handleSelect = (ranges) => {
        const selection = ranges.selection;
        const {startDate, endDate} = selection;
        setSelectedDateRange([selection]);

        if (!startDate || !endDate) {
            return;
        }

        const sameDay = moment(startDate).isSame(endDate, 'day');

        // First click usually sets start === end; wait for the end-date click (including same-day).
        if (sameDay && !awaitingEndDate) {
            setAwaitingEndDate(true);
            return;
        }

        applyRange(startDate, endDate);
    };

    const handleClear = (event) => {
        event.stopPropagation();
        setAwaitingEndDate(false);
        setSelectedDateRange([
            {
                startDate: undefined,
                endDate: undefined,
                key: 'selection',
            },
        ]);
        header.column.setFilterValue(undefined);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'date-range-popover' : undefined;
    const filterValue = column.getFilterValue();

    return (
        <>
            <TextField
                fullWidth
                placeholder="Select Date Range"
                value={!filterValue
                    ? ''
                    : `${formatFilterLabelDate(filterValue[0])} - ${formatFilterLabelDate(filterValue[1])}`
                }
                onClick={handleClick}
                variant="standard"
                readOnly
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                disabled={filterValue == null}
                                size="small"
                                onClick={handleClear}
                            >
                                <ClearIcon fontSize="small"/>
                            </IconButton>
                        </InputAdornment>
                    ),
                }}
            />
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <DateRange
                    ranges={selectedDateRange}
                    onChange={handleSelect}
                    moveRangeOnFirstSelection={false}
                    retainEndDateOnFirstSelection
                />
            </Popover>
        </>
    );
};

export default DateRangePicker;
